import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor, _descriptor2;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { computed, makeObservable, obx } from '@alilc/lowcode-editor-core';
import { IPublicEnumPluginRegisterLevel } from '@alilc/lowcode-types';
import { flow } from 'mobx';
import { BasicContext } from './base-context';
import { getWebviewPlugin } from '../inner-plugins/webview';
export var Context = (_class = /*#__PURE__*/function (_BasicContext) {
  _inheritsLoose(Context, _BasicContext);
  function Context(workspace, editorWindow, editorView, options) {
    var _this;
    _this = _BasicContext.call(this, workspace, editorView.viewName, IPublicEnumPluginRegisterLevel.EditorView, editorWindow) || this;
    _this.workspace = workspace;
    _this.editorWindow = editorWindow;
    _this.editorView = editorView;
    _this.viewName = 'editor-view';
    _this.instance = void 0;
    _this.viewType = void 0;
    _initializerDefineProperty(_this, "_activate", _descriptor, _assertThisInitialized(_this));
    _initializerDefineProperty(_this, "isInit", _descriptor2, _assertThisInitialized(_this));
    _this.init = flow( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$instance2, _this$instance2$init;
      var _this$instance, _this$instance$url, url;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(this.viewType === 'webview')) {
              _context.next = 8;
              break;
            }
            _context.next = 3;
            return (_this$instance = this.instance) === null || _this$instance === void 0 ? void 0 : (_this$instance$url = _this$instance.url) === null || _this$instance$url === void 0 ? void 0 : _this$instance$url.call(_this$instance);
          case 3:
            url = _context.sent;
            _context.next = 6;
            return this.plugins.register(getWebviewPlugin(url, this.viewName));
          case 6:
            _context.next = 10;
            break;
          case 8:
            _context.next = 10;
            return this.registerInnerPlugins();
          case 10:
            _context.next = 12;
            return (_this$instance2 = this.instance) === null || _this$instance2 === void 0 ? void 0 : (_this$instance2$init = _this$instance2.init) === null || _this$instance2$init === void 0 ? void 0 : _this$instance2$init.call(_this$instance2);
          case 12:
            _context.next = 14;
            return this.innerPlugins.init();
          case 14:
            this.isInit = true;
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    _this.onSimulatorRendererReady = function () {
      return new Promise(function (resolve) {
        _this.project.onSimulatorRendererReady(function () {
          resolve();
        });
      });
    };
    _this.setActivate = function (_activate) {
      _this._activate = _activate;
      _this.innerHotkey.activate(_this._activate);
    };
    _this.viewType = editorView.viewType || 'editor';
    _this.viewName = editorView.viewName;
    _this.instance = editorView(_this.innerPlugins._getLowCodePluginContext({
      pluginName: 'any'
    }), options);
    makeObservable(_assertThisInitialized(_this));
    return _this;
  }
  var _proto = Context.prototype;
  _proto.save = /*#__PURE__*/function () {
    var _save = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$instance3, _this$instance3$save;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (_this$instance3 = this.instance) === null || _this$instance3 === void 0 ? void 0 : (_this$instance3$save = _this$instance3.save) === null || _this$instance3$save === void 0 ? void 0 : _this$instance3$save.call(_this$instance3);
          case 2:
            return _context2.abrupt("return", _context2.sent);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function save() {
      return _save.apply(this, arguments);
    }
    return save;
  }();
  _createClass(Context, [{
    key: "active",
    get: function get() {
      return this._activate;
    }
  }]);
  return Context;
}(BasicContext), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_activate", [obx], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isInit", [obx], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "active", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "active"), _class.prototype)), _class);